import React from 'react'

import FieldLabel from '@react/react-spectrum/FieldLabel'
import { RichTextFormField } from 'components/RichTextEditor'

const Details = ({ screen, disabled, onChange }) => {
  const content = screen?.content
  return (
    <>
      <FieldLabel label='Summary'>
        <RichTextFormField
          label='subtitle'
          value={content.subtitle || ''}
          onChange={onChange('subtitle')}
          disabled={disabled}
        />
      </FieldLabel>
    </>
  )
}

export default [{ label: 'Details', content: Details }]
